import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import DeliveryChargeForm from "./DeliveryChargeForm";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createDeliveryChargeValidation } from "../../utils/validationSchemas";

const CreateDeliveryCharge = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeValidation),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <DeliveryChargeForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </FormLayout>
  );
};


export default CreateDeliveryCharge